// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"368":"4dcffa89","437":"db8f4e29","470":"ed21affd","847":"3bbfa028"}[chunkId] + ".chunk.css";
};